export const actors = [
  {
    id: "actor-lin",
    name: "林清月",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20elegant%20young%20Chinese%20actress%20in%20a%20soft%20beige%20top%2C%20neutral%20gray%20studio%20background%2C%20soft%20cinematic%20lighting%2C%20editorial%20headshot&width=400&height=400&seq=actor-lin-qingyue-01&orientation=squarish",
    birth: "1993-04-12",
    region: "中国大陆",
    height: "168cm",
    bio: "毕业于中央戏剧学院表演系，以细腻克制的表演风格著称。出演过多部古装与年代题材作品，被观众称为“剧抛脸”。代表作《长安烟雨录》《山河故人梦》。",
    works: ["drama-001", "drama-004", "drama-009", "drama-011"],
  },
  {
    id: "actor-gu",
    name: "顾南亭",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20calm%20young%20Chinese%20actor%20in%20a%20dark%20shirt%2C%20neutral%20charcoal%20studio%20background%2C%20moody%20cinematic%20lighting%2C%20editorial%20headshot&width=400&height=400&seq=actor-gu-nanting-01&orientation=squarish",
    birth: "1990-09-28",
    region: "中国大陆",
    height: "183cm",
    bio: "上海戏剧学院毕业，擅长塑造冷静理智的硬派角色。凭借悬疑题材作品走红，戏路宽广，从刑警到普通人都有出色演绎。代表作《都市迷航》《深巷之光》。",
    works: ["drama-002", "drama-005", "drama-009", "drama-012"],
  },
  {
    id: "actor-su",
    name: "苏晚晴",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20intelligent%20young%20Chinese%20actress%20in%20a%20white%20blouse%2C%20light%20gray%20studio%20background%2C%20clean%20soft%20lighting%2C%20editorial%20headshot&width=400&height=400&seq=actor-su-wanqing-01&orientation=squarish",
    birth: "1995-01-06",
    region: "中国大陆",
    height: "170cm",
    bio: "北京电影学院毕业，气质清冷，表演富有层次。近年来活跃于悬疑与青春题材，善于诠释外冷内热的女性角色。代表作《深巷之光》《逆光而行》。",
    works: ["drama-002", "drama-005", "drama-007", "drama-010", "drama-012"],
  },
  {
    id: "actor-shen",
    name: "沈砚舟",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20mature%20handsome%20Chinese%20actor%20in%20a%20navy%20suit%2C%20dark%20neutral%20studio%20background%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20headshot&width=400&height=400&seq=actor-shen-yanzhou-01&orientation=squarish",
    birth: "1988-11-19",
    region: "中国大陆",
    height: "185cm",
    bio: "出演话剧出身，台词功底扎实。以古装与年代剧中的沉稳角色为观众熟知，气场十足，是实力派代表演员之一。代表作《长安烟雨录》《山河故人梦》。",
    works: ["drama-001", "drama-004", "drama-007", "drama-011"],
  },
  {
    id: "actor-jiang",
    name: "江北辰",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20charismatic%20young%20Chinese%20actor%20in%20a%20black%20leather%20jacket%2C%20deep%20blue%20studio%20background%2C%20moody%20cinematic%20lighting%2C%20editorial%20headshot&width=400&height=400&seq=actor-jiang-beichen-01&orientation=squarish",
    birth: "1994-07-03",
    region: "中国大陆",
    height: "184cm",
    bio: "运动员转型演员，动作戏出色，气质硬朗又不失少年感。横跨武侠、爱情与青春题材，深受年轻观众喜爱。代表作《大漠孤烟》《星辰与你》。",
    works: ["drama-001", "drama-003", "drama-007", "drama-010", "drama-011"],
  },
  {
    id: "actor-wen",
    name: "温之夏",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20fresh%20natural%20young%20Chinese%20actress%20in%20a%20sweater%2C%20warm%20cream%20studio%20background%2C%20gentle%20soft%20lighting%2C%20editorial%20headshot&width=400&height=400&seq=actor-wen-zhixia-01&orientation=squarish",
    birth: "1996-03-21",
    region: "中国大陆",
    height: "166cm",
    bio: "新生代女演员，外形清新，表演自然灵动。擅长都市职场与治愈系角色，是近年上升势头明显的年轻演员。代表作《星辰与你》《硅谷玫瑰》。",
    works: ["drama-003", "drama-005", "drama-006", "drama-008", "drama-010"],
  },
  {
    id: "actor-lu",
    name: "陆行舟",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20sharp%20young%20Chinese%20actor%20in%20a%20gray%20knit%20sweater%2C%20cool%20neutral%20studio%20background%2C%20cinematic%20side%20lighting%2C%20editorial%20headshot&width=400&height=400&seq=actor-lu-xingzhou-01&orientation=squarish",
    birth: "1991-05-15",
    region: "中国大陆",
    height: "182cm",
    bio: "中戏毕业，学霸型演员，逻辑清晰、反应敏捷。在悬疑与职场题材中塑造了多个高智商角色，本人亦常受邀参与剧本研讨。代表作《午夜列车》《都市迷航》。",
    works: ["drama-002", "drama-004", "drama-008", "drama-012"],
  },
  {
    id: "actor-bai",
    name: "白清欢",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20bright%20cheerful%20young%20Chinese%20actress%20with%20a%20soft%20smile%2C%20light%20peach%20studio%20background%2C%20warm%20soft%20lighting%2C%20editorial%20headshot&width=400&height=400&seq=actor-bai-qinghuan-01&orientation=squarish",
    birth: "1997-08-30",
    region: "中国大陆",
    height: "167cm",
    bio: "外形甜美、性格开朗，以都市轻喜剧和家庭温情剧见长。表演松弛自然，擅长为角色增添生活化的细节，被称为“荧屏小太阳”。代表作《春风十里长街》《四时安好》。",
    works: ["drama-003", "drama-006", "drama-008", "drama-009"],
  },
];